import React, { useEffect, useState } from "react";
import {
  IoCheckmarkOutline,
  IoCubeOutline,
  IoNavigateOutline,
  IoHomeOutline,
  IoCheckmarkCircleOutline,
} from "react-icons/io5";
import "./pages.css";
import { useSetDeliveryAddressMutation, useGetOrdersQuery, useOrderPayMutation } from "../store/api/orderApi";

import OrderFilter from "../components/OrderFilter";
import OrderCard from "../components/OrderCard";
import DeliveryModal from "../components/DeliveryModal";


const orderTabs = [
  { label: "Заказано", icon: <IoCheckmarkOutline />, status: 0 },
  { label: "На складе", icon: <IoCubeOutline />, status: 15 },
  { label: "В пути", icon: <IoNavigateOutline />, status: 16 },
  { label: "На ПВЗ", icon: <IoCheckmarkCircleOutline />, status: 29 },
];

const OrderList = () => {
  const [activeStatus, setActiveStatus] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orderPay] = useOrderPayMutation();
  const [showQR, setShowQR] = useState(false);
  const [qrBase64, setQrBase64] = useState(null);
  const [openDeliveryModal, setOpenDeliveryModal] = useState(false);

  const [changePickupOrder] = useSetDeliveryAddressMutation();
  const { data: orders = [] } = useGetOrdersQuery(activeStatus ?? 0);

  const totalShippingKR =
    activeStatus === 18 || activeStatus === 29
      ? (orders ?? []).reduce((sum, o) => {
        const weight = Math.ceil((o.gross_weight ?? 0) * 10) / 10;
        let rate = 0;

        if (o.country_guid === "9B785514-12A9-4336-A927-C36A46596D3D") {
          rate = 900;
        } else if (
          o.country_guid === "A4D9A734-CCEC-49AF-A5B5-6D5765639D21"
        ) {
          rate = 1200;
        }
        if (o.current_payment_status == 2) return sum;
        if (o.shipping_cost) return sum + o.shipping_cost;
        return sum + weight * rate;
      }, 0)
      : 0;


  return (
    <>
      <div className="order">
        <DeliveryModal
          isOpen={openDeliveryModal}
          onClose={() => setOpenDeliveryModal(false)}
          handleSkip={() => setOpenDeliveryModal(false)}
          onAccept={(form) => {
            [...orders].forEach(async or => {
              await changePickupOrder({ ...form, guid: or.guid });
            })
          }}
          value={orders[0]?.address_delivery}
          btnTitle={"Сохранить"}
          rejectTitle={"Отмена"}
          title="Доставка и адрес"
          description=""
        />
        <OrderFilter
          orderTabs={orderTabs}
          activeStatus={activeStatus || 0}
          onChange={setActiveStatus}
        />

        <div className="cards">
          {orders.map((order) => (
            <OrderCard
              key={order.guid}
              order={order}
              onClick={setSelectedOrder}
            />
          ))}

          {(activeStatus === 29) && orders?.length > 0 && (
            <div className="pvz-total-box">
              <div className="pvz-total-row">
                <span>Итого к оплате:</span>
                <strong>{parseInt(totalShippingKR)} сом</strong>
              </div>

              <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
                <button className="pay-btn" onClick={async () => {

                  const orderList = orders.map(or => or.guid);

                  const data = await orderPay({
                    orders: orderList,      // массив guid
                    summa: totalShippingKR
                  });
                  setShowQR(true)
                  setQrBase64(data.data.qr.data.qr_base64)
                }}>
                  Оплатить
                </button>
                {(activeStatus === 18 || activeStatus === 29) && (
                  <button
                    className="delivery-btn"
                    onClick={() => {
                      const phone = "996227080009"; // номер в международном формате БЕЗ +
                      const message = "Здравствуйте!";

                      window.open("https://wa.me/996227080008", "_blank")
                    }}
                  >
                    Оформить доставку
                  </button>
                )}
              </div>
            </div>
          )}
        </div>

        {showQR && (
          <div className="qr-modal">
            <div className="qr-content">
              <h3>Оплата через QR</h3>

              <img
                src={qrBase64}
                alt="QR для оплаты"
                style={{ width: 290, borderRadius: 12 }}
              />

              <p style={{ marginTop: 12 }}>
                Отсканируйте QR в приложении банка
              </p>

              <button
                className="close-btn"
                onClick={async () => {
                  setShowQR(false)
                }}
              >
                Закрыть
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default OrderList;
